
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Button,
  Upload,
  Select,
  Option,
  InputNumber,
  Row,
  Col,
} from 'element-ui';
import myVditor from '@/components/Markdown/vditor.vue';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Button,
    Upload,
    Select,
    Option,
    InputNumber,
    Row,
    Col,
    myVditor,
  },
})

export default class firstStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  @Prop({
    required: true,
    default: false,
  }) title!: any;

  private fileListIcon: any = [];

  private fileListImg: any = [];

  public form: any = {
    stepTitle: '',
    stepDescription: '',
    previous: '',
    stepSeq: 0,
    editorType: '',
  }

  public loading: boolean = false;

  private versions: { value: number; label: string; }[] = [{ value: 2, label: 'Scratch2.0' }, { value: 3, label: 'Scratch3.0' }];

  private previous: { value: number; label: string; }[] = [{ value: 0, label: '是' }, { value: 1, label: '否' }];

  public $refs!: {
    form: Form,
    myVditor: myVditor,
  };

  private rules: any = {
    stepTitle: [
      { required: true, message: '请填写标题', trigger: 'change' },
    ],
    stepDescription: [
      { required: true, message: '请填写简介', trigger: 'change' },
    ],
    stepSeq: [
      { required: true, message: '请填写步骤', trigger: 'change' },
    ],
    previous: [
      { required: true, message: '必须选择是否创建默认作品', trigger: 'change' },
    ],
  };

  private editorTypeList: any = [
    {
      label: 'Scratch 3.0',
      value: 'U2FsdGVkX',
    },
    {
      label: 'Python',
      value: 'DnVaryx0CLJv',
    },
    {
      label: 'C++',
      value: '65S6k67PR',
    },
    {
      label: 'Microbit',
      value: 'A9UdYEdHP',
    },
    {
      label: 'Javascript',
      value: '184w1oQFh',
    },
    {
      label: 'HTML5',
      value: '18KIo5Rs8v1',
    },
    {
      label: 'Scratch 2.0',
      value: 'zKTYcHqz8P',
    },
  ]

  mounted() {
    if (this.title.includes('修改')) {
      const {
        pid,
        stepTitle,
        stepDescription,
        previous,
        stepSeq,
        editorType,
      } = this.oldForm;
      this.form = {
        pid,
        stepTitle,
        stepDescription,
        previous,
        stepSeq,
        editorType,
      };
      this.fileListImg = [{ url: this.oldForm.stepImagePath }];
    }
  }


  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListImg = [{ url: e.target.result }];
    };
    this.form.stepImage = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.stepImage = '';
  }

  /**
   * @author liangyongmou
   * @desc 简介编辑器输入事件
   * @param { string } value 编辑器内容
   */
  handleStepDescriptionInput(value: string) {
    this.form.stepDescription = value || '';
    // 清除该字段的验证错误，当用户输入内容后，错误提示会消失
    this.$nextTick(() => {
      if (this.$refs.form) {
        this.$refs.form.clearValidate('stepDescription');
      }
    });
  }

  /**
   * @author liangyongmou
   * @desc 提交事件
   * @param 空
   */
  handleSubmit() {
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        // 获取 markdown 编辑器的值
        if (this.$refs.myVditor) {
          const markdownValue = this.$refs.myVditor.getMarkdownValue();
          this.form.stepDescription = markdownValue || '';
        }
        result = this.form;
      }
    });
    return result;
  }
}
